import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DocumentSignature, DocumentSignatureCreate, DocumentSignatureFilter } from '../data/documentSignature';

export function createDocumentSignatureService(client: AxiosInstance) {
  return createCrudService<DocumentSignature, DocumentSignatureCreate, DocumentSignatureFilter>(
    client,
    '/document-management/DocumentSignature',
    'id',
  );
}

export type DocumentSignatureService = CrudService<DocumentSignature, DocumentSignatureCreate, DocumentSignatureFilter>;
